import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { triggerNotification } from '../../../helpers/notification';
import AnalyticsReportView from './AnalyticsReportView';
import { REPORT_HEADER_LIST, REPORT_HEADER_TYPE_ENUM } from './reportsConfig';

const ReportView = ({
  entityId,
  reportConfigs,
  onGenerateReport,
  redirectPath,
  reportResult,
  reportViewType,
  isAdminView,
  viewAsOptions,
  hasExternalConnections,
  urlBase,
  resourcesLoading
}) => {
  const [reportLoading, setReportLoading] = useState(false);

  const onFetchAnalyticsReport = (uuid, requestData) => {
    setReportLoading(true);
    onGenerateReport(
      {
        uuid,
        ...requestData,
        filters:
          requestData.filters?.map((filter) => {
            const reportHeader = REPORT_HEADER_LIST.find(
              (r) => r.value === filter.field
            );

            if (reportHeader?.type === REPORT_HEADER_TYPE_ENUM.CURRENCY) {
              return {
                ...filter,
                values: filter.values.map((v) => (v * 100).toString())
              };
            }
            return filter;
          }) || []
      },
      () => setReportLoading(false),
      (error) => {
        setReportLoading(false);
        triggerNotification(error);
      }
    );
  };

  return (
    <AnalyticsReportView
      entityId={entityId}
      isAdminView={isAdminView}
      loading={reportLoading}
      onFetchReport={onFetchAnalyticsReport}
      redirectPath={redirectPath}
      reportConfigs={reportConfigs.filter(
        (c) => !c.isExternalOnly || hasExternalConnections
      )}
      reportResult={reportResult}
      reportViewType={reportViewType}
      resourcesLoading={resourcesLoading}
      urlBase={urlBase}
      viewAsOptions={viewAsOptions}
    />
  );
};

ReportView.propTypes = {
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasExternalConnections: PropTypes.bool,
  isAdminView: PropTypes.bool,
  onGenerateReport: PropTypes.func,
  redirectPath: PropTypes.string,
  reportConfigs: PropTypes.array,
  reportResult: PropTypes.object,
  reportViewType: PropTypes.string,
  resourcesLoading: PropTypes.bool,
  urlBase: PropTypes.string,
  viewAsOptions: PropTypes.array
};

export default ReportView;
